// extracted by mini-css-extract-plugin
export default {"card":"Login_card__dHBmA"};